import { render, staticRenderFns } from "./ShortLBOSearchDisplayer.vue?vue&type=template&id=36545b91&scoped=true"
import script from "./ShortLBOSearchDisplayer.vue?vue&type=script&lang=ts"
export * from "./ShortLBOSearchDisplayer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36545b91",
  null
  
)

export default component.exports